<template>
  <div>
    <v-container class="py-5" fluid>
      <v-row justify="center">
        <v-col cols="12" md="6">
          <v-card class="pa-4 elevation-3 rounded-lg">
            <v-card-title class="text-h6 font-weight-medium text-center mb-4">
              Select an Option
            </v-card-title>
            <v-card-text>
              <v-select
                v-model="selectedOption"
                :items="options"
                label="Choose a Fruit"
                item-title="text"
                item-value="value"
                variant="outlined"
                density="compact"
                clearable
              ></v-select>

              <v-alert
                v-if="selectedOption"
                type="info"
                class="mt-4 rounded-lg"
                density="compact"
                text
              >
                You selected: <strong>{{ selectedOptionText }}</strong
                ><br />
                Corresponding Code (variable_A):
                <strong>{{ variable_A }}</strong>
              </v-alert>
              <v-alert
                v-else
                type="warning"
                class="mt-4 rounded-lg"
                density="compact"
                text
              >
                Please select an option.
              </v-alert>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup>
import { ref, watch, computed } from "vue";

// 1. Reactive variable to hold the selected value from v-select
const selectedOption = ref(null); // Will hold the 'value' property from the selected item

// 2. The variable you want to change based on the selection
const variable_A = ref(null);

// 3. Define your options for the v-select
// Using an array of objects is flexible: 'text' for display, 'value' for internal binding
const options = ref([
  { text: "Apple", value: "0001" },
  { text: "Banana", value: "0002" },
  { text: "Cherry", value: "0003" },
  { text: "Durian", value: "0004" },
  { text: "Grape", value: "0005" },
]);

// 4. Use a 'watch' to react to changes in 'selectedOption'
watch(
  selectedOption,
  (newValue) => {
    if (newValue === "0001") {
      variable_A.value = "AppleCode"; // Or just '0001' if that's the desired value
    } else if (newValue === "0002") {
      variable_A.value = "BananaCode";
    } else if (newValue === "0003") {
      variable_A.value = "CherryCode";
    } else if (newValue === "0004") {
      variable_A.value = "DurianCode";
    } else if (newValue === "0005") {
      variable_A.value = "GrapeCode";
    } else {
      // Handle case where nothing is selected or cleared
      variable_A.value = null;
    }
  },
  { immediate: true }
); // 'immediate: true' runs the watch once on component mount

// Optional: A computed property to display the friendly text of the selected option
const selectedOptionText = computed(() => {
  const selected = options.value.find(
    (option) => option.value === selectedOption.value
  );
  return selected ? selected.text : "None";
});
</script>

<style scoped>
/* Add any component-specific styles here if needed */
</style>
